<template>
  <div class="site-wrapper site-page--page-loading">
    <div class="site-content__wrapper">
      <div class="site-content">
        <h2 class="page-loading-title">
          <i class="el-icon-loading"></i>
        </h2>
        <p class="page-loading-desc">页面加载中，请稍后...</p>
        <el-button type="primary" @click="$router.push('/Login')"
          >返回登录页</el-button
        >
        <el-button type="primary" @click="checkAuthor()">进入首页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  methods: {
    // 获取数据
    checkAuthor: function() {
      var query = this.$route.query;
      let edz_token = query.edz_token;
      let user = query.user;
      let init = query.init;
      //console.log("token=" + edz_token);
      if (edz_token && user) {
        this.$api.login
          .checkAuthor({ user: user, edz_token: edz_token })
          .then(res => {
            if (res.msg != null && res.msg != "") {
              // this.$message({
              //   message: res.msg,
              //   type: "error"
              // });
              this.$alert(res.msg, "操作异常", {
                confirmButtonText: "确定",
                callback: action => {
                  this.$router.push("/login");
                }
              });
            }
            //操作成功
            else if (res.code == 200) {
              //console.log("fist login:", res.data);
              let edzUser = res.data;
              // 存放对象到sessionStorage
              const edzUserJson = JSON.stringify(edzUser);
              sessionStorage.setItem("edzUser", edzUserJson); // 保存用户到本地会话
              Cookies.set("edz_token", edz_token); // 放置token到Cookie
              this.$store.commit("menuRouteLoaded", false); // 要求重新加载导航菜单

              if (init) {
                this.$router.push("/init"); // 登录成功，跳转到初始化页面
              } else {
                this.$router.push("/"); // 登录成功，跳转到主页
              }
            }
            // else {
            //   this.loadUserProfile();
            //   Cookies.set("edz_token", edz_token); // 放置token到Cookie
            //   this.$store.commit("menuRouteLoaded", false); // 要求重新加载导航菜单
            //   this.$router.push("/"); // 登录成功，跳转到主页
            // }
          })
          .catch(res => {
            this.$message({
              message: res.message,
              type: "error"
            });
          });
      }
    },
    loadUserProfile: function(data) {
      this.$api.user
        .getProfile()
        .then(res => {
          this.tableLoading = false;
          //操作成功
          if (res.code == 200) {
            let edzUser = res.data;
            // 存放对象到sessionStorage
            const edzUserJson = JSON.stringify(edzUser);
            sessionStorage.setItem("edzUser", edzUserJson); // 保存用户到本地会话
          } else {
            this.$message({
              message:
                "操作失败, [ code: " +
                res.code +
                "， message: " +
                res.msg +
                " ]",
              type: "error"
            });
          }
        })
        .then(data != null ? data.callback : "");
    }
  },
  mounted() {
    this.checkAuthor();
    //this.loadUserProfile();
  }
};
</script>

<style lang="scss">
.site-wrapper.site-page--page-loading {
  position: absolute;
  top: 60px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  .site-content__wrapper {
    padding: 0;
    margin: 0;
    background-color: #fff;
  }
  .site-content {
    position: fixed;
    top: 15%;
    left: 50%;
    z-index: 2;
    padding: 30px;
    text-align: center;
    transform: translate(-50%, 0);
  }
  .page-loading-title {
    margin: 20px 0 15px;
    font-size: 4em;
    font-weight: 500;
    color: rgb(55, 71, 79);
  }
  .page-loading-desc {
    margin: 0 0 30px;
    font-size: 26px;
    text-transform: uppercase;
    color: rgb(118, 131, 143);
    > em {
      font-style: normal;
      color: #ee8145;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Public/Loading.vue